import logoCreek from "../../common/assets/logoCreek.png";
import logoNuevamente from "../../common/assets/logoNuevamente.png";
import logoHangover from "../../common/assets/logoHangover.png";
import logoLeparc from "../../common/assets/logoLeparc.png";
//import logoLeparc from "../../common/assets/logoLeparc.png";


let logo = null;
const tenantId = process.env.REACT_APP_PRODUCT_ID;


if (tenantId == "creek") {
    logo = logoCreek;
}else if (tenantId == "nuevamente") {
    logo = logoNuevamente;
}else if (tenantId == "leparc") {
    logo = logoLeparc;
}else if (tenantId == "hangover") {
    logo = logoHangover;
}


export default logo;


// WEBPACK FOOTER //
// ./src/components/Header/LogoHeader.js